<script>
import { Bar } from 'vue-chartjs'
const brl = v => Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})

export default {
  name: 'GraficoBarraVendedoresGrande',
  extends: Bar,
  props: { data:Array, labels:Array, height:{type:Number,default:360} },
  methods: {
    montarGrafico () {
      // GraficoBarraVendedoresGrande.vue
      const brl = v => Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})
      const truncar = s => (s && s.length > 15 ? s.slice(0,15) + '…' : s)

      this.renderChart(
        { labels: this.labels, datasets: this.data.map(ds => ({
            ...ds, barThickness: 28, maxBarThickness: 36
        }))},
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display:false },
          tooltips: {
            callbacks: {
              title: items => this.labels[items[0].index],       // nome completo
              label: (it, data) => {
                const ds = data.datasets[it.datasetIndex]
                return `${ds.label||''} ${brl(it.yLabel)}`
              }
            }
          },
          scales: {
            xAxes: [{
              categoryPercentage: 0.95, barPercentage: 0.95,
              ticks: {
                maxRotation: 45, minRotation: 45,
                callback: v => truncar(v)                         // <-- truncar para 20
              }
            }],
            yAxes: [{ ticks: { beginAtZero:true, callback: v => brl(v) } }]
          }
        }
      )

    }
  },
  mounted(){ this.montarGrafico() },
  watch:{ labels(){this.montarGrafico()}, data(){this.montarGrafico()} },
  beforeDestroy(){ if (this._chart?.destroy) this._chart.destroy() }
}
</script>



// WEBPACK FOOTER //
// src/views/movimentos/vendas/GraficoBarraVendedoresGrande.vue